import { useEffect, useRef, useState } from 'react';

interface ScrollToProps {
  children: React.ReactNode;
  condition: boolean;
  onScroll?: () => void;
}

export function ScrollTo(props: ScrollToProps) {
  const { children, condition, onScroll } = props;
  const [hasScrolled, setHasScrolled] = useState(false);
  const targetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (condition && !hasScrolled && targetRef.current) {
      // RequestAnimationFrame to ensure the element is fully rendered and laid out so we can scroll to it
      requestAnimationFrame(() => {
        targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setHasScrolled(true);
        onScroll?.();
      });
    }
  }, [hasScrolled, condition, onScroll]);

  return <div ref={targetRef}>{children}</div>;
}
